import { PremiseTag } from 'app/premises/Premise';
import { FC } from 'react';

export type InterimSolutionIconProps = { tag?: PremiseTag };

export const InterimSolution: FC<InterimSolutionIconProps> = ({ tag }) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label={tag}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.425 5.085a3.05 3.05 0 0 0 0 6.1H15.64a4.425 4.425 0 1 1 0 8.851H.887a.2.2 0 0 1-.2-.2v-.975c0-.11.09-.2.2-.2H15.64a3.05 3.05 0 1 0 0-6.1H4.425a4.425 4.425 0 1 1 0-8.851h7.703v1.375H4.425z"
      fill="#037A35"
    />
    <path
      d="M12.535 4.387a2.935 2.935 0 0 1 2.934-2.935h1.576v5.87h-1.576a2.935 2.935 0 0 1-2.934-2.935z"
      stroke="#037A35"
      strokeWidth="1.38"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 3.353a.2.2 0 0 1-.2.2h-2.771a.2.2 0 0 1-.2-.2v-.85c0-.11.089-.2.2-.2H19.8c.11 0 .2.09.2.2v.85zM20 6.253a.2.2 0 0 1-.2.2h-2.913a.2.2 0 0 1-.2-.2v-.85c0-.11.09-.2.2-.2h2.912c.11 0 .2.09.2.2v.85z"
      fill="#037A35"
    />
  </svg>
);
